import React from 'react';
import { PropTypes } from 'prop-types';
import { toString } from 'lodash';
import { Icons, SecurityHelper, Button, Tooltip } from 'sarsaparilla';
import { GridCell } from './detailed-availability-page/Grid';

const propTypes = {
  isWalkup: PropTypes.bool,
  isLottery: PropTypes.bool,
  count: PropTypes.number,
  isSelected: PropTypes.bool,
  selectedGroupSize: PropTypes.number,
  onSelectToggle: PropTypes.func
};

const defaultProps = {};

export default class AvailabilityCell extends React.Component {
  renderUnavailable(displayCount) {
    return (
      <GridCell className="unavailable">
        <div className="rec-full-button-wrap">
          <Button
            isDisabled
            className="rec-availability-date">
            {displayCount}
          </Button>
        </div>
      </GridCell>
    );
  }
  
  render() {
    let displayCount = toString(this.props.count);

    if (this.props.count >= 99) {
      displayCount = `99+`;
    }
    if (this.props.isSelected) {
      return (
        <GridCell className="selected" >
            <div className="rec-full-button-wrap">
              <Button
                className="rec-availability-date"
                onClick={this.props.onSelectToggle}
                iconBeforeElement={<Icons.IconCheck />} />
            </div>
        </GridCell>
      );
    }
    if (this.props.isLottery) {
      const label = [
        'This day is being managed by the lottery',
        'Please refer to important dates for application process'
      ].join('\u000A');
      return (
        <GridCell className="lottery">
            <div className="rec-full-button-wrap">
                <Tooltip content={label}>
                    <Button
                        isDisabled
                        className="rec-availability-date"
                        aria-label={label}>
                        L
                    </Button>
                </Tooltip>
            </div>
        </GridCell>
      );
    }
    else if (SecurityHelper.isCommercialAccount()) {
      return this.renderUnavailable(displayCount);
    }
    else if (this.props.count && this.props.count > 0 && this.props.count >= this.props.selectedGroupSize) {
      return (
        <GridCell className="available">
          <div className="rec-full-button-wrap">
              <Button
                  className="rec-availability-date"
                  onClick={this.props.onSelectToggle}>
                  {displayCount}
              </Button>
          </div>
        </GridCell>
      );
    }
    else if (this.props.count && !this.props.isWalkup) {
      return this.renderUnavailable(displayCount);
    }
    else if (this.props.isWalkup) {
      const label = ['Walkup', 'This is available at the facility on the day of'].join('\u000A');
      return (
        <GridCell className="walk-up">
            <div className="rec-full-button-wrap">
                <Tooltip content={label}>
                    <Button
                        isDisabled
                        className="rec-availability-date"
                        aria-label={label}>
                        W
                    </Button>
                </Tooltip>
            </div>
        </GridCell>
      );
    }
    return this.renderUnavailable(displayCount);

  }
}

AvailabilityCell.propTypes = propTypes;
AvailabilityCell.defaultProps = defaultProps;

